import { IssueChallengeAction, IssueChallengeResult } from './issue-challenge';
import { sameOriginRequestPolicy } from '../../actions';
import { HTTP_STATUS_OK } from '../../../../helpers/validation/common';
import { parseChallengeFailure } from '../../challenge-failure';

export class RemoteIssueChallengeAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: IssueChallengeAction = async (): Promise<IssueChallengeResult> => {
		const base: string = this.baseUrl || '';
		const response: Response = await fetch(
			`${base}/api/challenge/issue`,
			{
				...sameOriginRequestPolicy,
				method: 'POST',
			},
		);
		if (response.status === HTTP_STATUS_OK) {
			return response.json();
		}

		return parseChallengeFailure(response, 'Failed to issue challenge');
	};
}
